import { useContext, useState } from 'react'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useRestApi } from '../../../lib/RestApi/useRestApi'
import { API_URL } from '../../../shared/actions'

export const useTasks = () => {
  const [task, setTask] = useState(false)
  const { deleteNewTask, getNewTask } = useContext(OtherContext)
  const [loading, setLoading] = useState(false)
  const [paginate, setPaginate] = useState(false)

  const { ADD, GET_ALL, UPDATE, GET_SINGLE_DATA, DELETE } = useRestApi(setLoading, 'Task', 'ALL_TASK', 'GET_ALL_TASK')
  const {
    TASK: { GET_ALL_TASK, ADD_TASK, EDIT_TASK, DELETE_MANY_TASK },
  } = API_URL

  const getAllTask = async (dto = {}) => {
    GET_ALL(GET_ALL_TASK, setPaginate, getNewTask, dto)
  }

  const addTask = (dto) => {
    ADD(ADD_TASK, dto)
  }

  const updateTask = (dto) => {
    UPDATE(EDIT_TASK, dto)
  }

  const getTask = (dto) => {
    GET_SINGLE_DATA(GET_ALL_TASK, setTask, dto)
  }

  const deleteManyTask = (dto, setSelected = () => {}) => {
    console.log({ dto })
    DELETE(DELETE_MANY_TASK, dto, 'taskId', setSelected, deleteNewTask, 'GET_ALL_TASK')
  }

  return {
    addTask,
    getAllTask,
    getTask,
    task,
    updateTask,
    deleteManyTask,
    loading,
    paginate,
  }
}
